export const ConnectionStatus = {
  NotConfigured: 0,
  Disabled: 1,
  Enabled: 2,
} as const;

export const UserProvisioning = {
  Password: 0,
  Sso: 1,
} as const;

export const TeamProvisioning = {
  Manual: 0,
  Scim: 1,
} as const;

export function isConfigured(status: number): boolean {
  return status !== ConnectionStatus.NotConfigured;
}

export function isEnabled(status: number): boolean {
  return status === ConnectionStatus.Enabled;
}
